import memoize from 'memoize-one';
import { isEmpty, isNil } from '../utils/fp';
import { getTerm, getConstraints } from './router';

const getSearch = state => state?.search;

export const getRows = memoize(state => getSearch(state)?.rows);

export const getHasNoSearchParams = memoize(state => {
  const term = getTerm(state);
  const constraints = getConstraints(state);

  const isTermEmpty = isEmpty(term) || isNil(term);
  const areConstraintsEmpty = isEmpty(constraints) || isNil(constraints);

  return isTermEmpty && areConstraintsEmpty;
});
